import { ButtonHTMLAttributes, ComponentProps, FC, ReactNode } from 'react';
import { Button as MuiButton } from '@wellstone-solutions/web';

import type { SxProps } from '@mui/material';

interface ButtonProps
  extends ComponentProps<typeof MuiButton>,
    ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  color?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'contained' | 'outlined' | 'text';
  sx?: SxProps;
}

const Button: FC<ButtonProps> = (props) => {
  const { children, sx, ...rest } = props;

  const mergedStyles = {
    minWidth: '50%',
    ...(typeof sx === 'object' ? sx : {}),
  };

  return (
    <MuiButton sx={mergedStyles} {...rest}>
      {children}
    </MuiButton>
  );
};

export { Button };
